import type { IconName } from '@/shared/ui'

export const REPORT_TOOLBAR_ICONS = {
  platform: 'diagram-project',
  tableType: 'diagram-project',
  breakdown: 'objects-align-right',
  frequency: 'clock',
  savedViews: 'bookmark',
  sort: 'arrow-up-wide-short',
  customize: 'sliders',
  enterFullscreen: 'expand',
  exitFullscreen: 'compress',
  more: 'ellipsis-vertical',
} as const satisfies Record<string, IconName>
